import { useCallback, useState } from 'react';

import { getPassportIframe } from '@VDL/api';
import { isAxiosError } from 'axios';

export const useFetchPassportIframe = () => {
  const [iframe, setIframe] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  const fetchIframe = useCallback(async (level0Code: string) => {
    setIframe(null);
    setError(null);
    setLoading(true);

    let result;

    try {
      const response = await getPassportIframe(level0Code);

      setIframe(response.data);
      result = response.data;
    } catch (error) {
      if (isAxiosError(error)) setError(error.message);
      else setError('Неизвестная ошибка');
    } finally {
      setLoading(false);
    }

    return result;
  }, []);

  return { fetchIframe, iframe, error, loading };
};
